// Page questionnaire coachs. À brancher sur une route (ex. /questionnaire/coach).
import React from 'react';
import SurveyWizard from './SurveyWizard';

export default function SurveyCoachPage() {
  // Accent bleu-violet (thème Sport/coach de CycleGala).
  return <SurveyWizard form="coach" accent="#5B4DE5" />;
}
